import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ReportsService } from 'src/app/services/reports.service';
import { UserService } from 'src/app/services/user.service';
import { ApproveDialogComponent } from '../../approve-dialog/approve-dialog.component';
import { CommonPdfComponent } from '../../common-pdf/common-pdf.component';
import { UserData } from '../../model/user-data';
import { UsersDataResponse } from '../../model/users-data-response';

@Component({
    selector: 'app-missing-signature-report',
    templateUrl: './missing-signature-report.component.html',
    styleUrls: ['./missing-signature-report.component.scss'],
    standalone: false
})
export class MissingSignatureReportComponent extends CommonPdfComponent implements OnInit {
  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  
  msrForm: UntypedFormGroup;
  storeData:[]=[];
  storeNumber:string=null;
  dcNumber:number=null;
   filter:string='';
  minDate:Date=new Date();
  maxDate:Date=new Date();
  
  options:string[]=[];
  isDataloaded:boolean=true;

  displayFn(storeData): string {
    return storeData ? storeData : '';
  }

  private _filter(name: string): string[] {
    const filterValue = name.toLowerCase();

    return this.options.filter(option => option.toLowerCase().indexOf(filterValue) === 0);
  }
  constructor(private route: ActivatedRoute,private userservice:UserService,
    private reportsService: ReportsService, private fb: UntypedFormBuilder,private router:Router,protected dialog:MatDialog) {
      super(dialog);
     }

  displayedColumns: string[] = ['statusName', 'purchaseOrder', 'poReceivedDate', 'signedBy'];
  
  userData:UserData;
  user:UsersDataResponse;
  


  
  ngOnInit(): void {
   
  
 
  this.userservice.getCurrentUser().subscribe(data=>{
    this.user=data;
    this.userData=data.userData;
    if(this.userData.roleId<4){
      this.createFormDc();
      }else{
        this.createFormStore();
      }
   
  })
    
    
   
  }
  
  

  

  createFormDc() {
    this.msrForm = this.fb.group({
      storeNumber: [''],
      dcNumber:['',Validators.required],
      fromDate:['',Validators.required],
      toDate:['',Validators.required],
      overdue:[true,Validators.required],
      late:[true,Validators.required]
  
   
      
    });

  }

  createFormStore() {
    this.msrForm = this.fb.group({
      storeNumber: ['', Validators.required],
      dcNumber:[null],
      fromDate:['',Validators.required],
      toDate:['',Validators.required],
      overdue:[true,Validators.required],
      late:[true,Validators.required]
  
   
      
    });

  }

  openMSRReport(){
    if(this.validate()){
    let fromDate = JSON.stringify(this.msrForm.controls.fromDate.value)
    fromDate = fromDate.slice(1,11);
    let toDate = JSON.stringify(this.msrForm.controls.toDate.value)
    toDate = toDate.slice(1,11);
  this.reportsService.getMSRReport(this.msrForm.value,fromDate,toDate).subscribe(data=>{
    this.isDataloaded=true;
    console.log(data.headers.get('Content-Disposition'));
    let contentDispositionHeader= data.headers.get('Content-Disposition')
     var result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
     result.replace(/"/g, '');
     console.log(result);
     this.isDataloaded=true;
    let dialogData= {
     title: result,
       downloadFileName: result,
       downLoadFile:true
     }
    this.openReport(data.body,dialogData);
  //   this.dialog.open(PdfViewerComponent, {
  //     width: '100%',
  //     maxWidth: '90%',
  //     height: 'auto',
  //     data: {
  //       title: 'TEST',
  //       srcType: 'Binary',
  //       pdfData: new Blob([data], { type: 'application/pdf' }),
  //       downloadFileName: "Test.pdf",
  //       downLoadFile:true
  //     }
  //   });
   },(error:HttpErrorResponse)=>{
     
    if(error && error.status===404){
    let dialogData= {
      title: this.userData.language==="EN"?'No Records Found':"Aucune transaction trouvée",
      message: this.userData.language==="EN"?"No records to display.":"Aucune transaction à afficher",
     
    }
    this.dialog.open(ApproveDialogComponent,{
      data:dialogData,panelClass: 'my-class'
    });
  }
})

  }

  
  }  
validate(){
  let valid=false;
  let late=this.msrForm.controls.late.value;
  let overdue=this.msrForm.controls.overdue.value;
  if(late===false && overdue ===false){
  let dialogData= {
    title: 'Alert',
    message: "Atleast overdue/late is mandatory.",
   
  }
  this.dialog.open(ApproveDialogComponent,{
    data:dialogData,panelClass: 'my-class'
  });
}else{
   valid=true;

}
return valid;
}
  


advancedSearch(){
    console.log(this.filter);
    console.log(this.filter);
}



}
